/*
 *
 *   reducer
 *
 */
import produce from "immer"
// import key from "./key"

import {
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  
  LOAD_FOLLOWUP_LIST_SUCCESS,
  LOAD_FOLLOWUP_LIST_ERROR,

  LOAD_CHECK_LIST_SUCCESS,
  LOAD_CHECK_LIST_ERROR,

  LOAD_TEAM_SCHEDULE_SUCCESS,
  LOAD_TEAM_SCHEDULE_ERROR,

  LOAD_EC_FOLLOWUP_LIST_SUCCESS,
  LOAD_EC_FOLLOWUP_LIST_ERROR,

  LOAD_EC_APP_SUCCESS,
  LOAD_EC_APP_ERROR,

  LOAD_EC_EVENT_SUCCESS,
  LOAD_EC_EVENT_ERROR,

  LOAD_DELIVERABLES_SUCCESS,
  LOAD_DELIVERABLES_ERROR,

  LOAD_DELIVER_META_DATA_SUCCESS,
  LOAD_DELIVER_META_DATA_ERROR,

  LOAD_DELIVERABLE_STATUS_SUCCESS,
  LOAD_DELIVERABLE_STATUS_ERROR,

  LOAD_ISSUES_SUCCESS,
  LOAD_ISSUES_ERROR,

  LOAD_CALL_ACTIONS_SUCCESS,
  LOAD_CALL_ACTIONS_ERROR,

  LOAD_CALL_CRITERIA_SUCCESS,
  LOAD_CALL_CRITERIA_ERROR,
  LOAD_DELIVERABLE_TAG_SUCCESS,
  LOAD_DELIVERABLE_TAG_ERROR,

  LOAD_CALL_RECORDING_SUCCESS,
  LOAD_CALL_RECORDING_ERROR,

  LOAD_REVIEW_SUCCESS,
  LOAD_REVIEW_ERROR,

} from "./constants"

const initialState = {
  record: [],
  followup_list: [],
  recordsMetaData:{},
  ec_followup_list: [],
  loading: false,
  error: false,
  success: false,
  check_list:[],
  team_list:[],
  app_list:[],
  event_list:[],
  deliver_list:[],
  deliverMetaData:{},
  deliverStatusData:[],
  issuesDetails:[],
  criteria_data:[],
  actions_data:[],
  tagData:[],
  call_Records:[],
  review_List:[]
}

export default function Reducer(
  state = initialState,
  {
   
    followup_list,
    check_list,
    team_list,
    type,
    ec_followup_list,
    error,
    success,
    recordsMetaData,
    app_list,
    event_list,
    deliver_list,
    deliverMetaData,
    deliverStatusData,
    issuesDetails,
    criteria_data,
    actions_data,
    tagData,
    call_Records,
    review_List
  }
) {
  return produce(state, (draft) => {
    switch (type) {
     
      case LOAD_FOLLOWUP_LIST_SUCCESS:
        draft.followup_list = followup_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
        case LOAD_EC_FOLLOWUP_LIST_SUCCESS:
          draft.ec_followup_list = ec_followup_list
          draft.lastUpdate = Math.floor(Date.now() / 1000)
          draft.loading = false
          draft.error = false
          draft.success = false
          break
        case LOAD_CHECK_LIST_SUCCESS:
          draft.check_list = check_list
          draft.lastUpdate = Math.floor(Date.now() / 1000)
          draft.loading = false
          draft.error = false
          draft.success = false
          break
          case LOAD_REVIEW_SUCCESS:
            draft.review_List = review_List
            draft.lastUpdate = Math.floor(Date.now() / 1000)
            draft.loading = false
            draft.error = false
            draft.success = false
            break
          case LOAD_DELIVERABLE_STATUS_SUCCESS:
            draft.deliverStatusData = deliverStatusData
            draft.loading = false
            draft.error = false
            draft.success = false
            break
            case LOAD_DELIVERABLE_TAG_SUCCESS:
              draft.tagData = tagData
              draft.loading = false
              draft.error = false
              draft.success = false
              break
            case LOAD_ISSUES_SUCCESS:
              draft.issuesDetails = issuesDetails
              draft.loading = false
              draft.error = false
              draft.success = false
              break
          case LOAD_TEAM_SCHEDULE_SUCCESS:
            draft.team_list = team_list
            draft.lastUpdate = Math.floor(Date.now() / 1000)
            draft.loading = false
            draft.error = false
            draft.success = false
            break
        case LOAD_RECORDS_META_DATA_SUCCESS:
          draft.recordsMetaData = recordsMetaData
          draft.loading = false
          draft.error = error
          draft.success = success
          break
          case LOAD_DELIVER_META_DATA_SUCCESS:
            draft.deliverMetaData = deliverMetaData
            draft.loading = false
            draft.error = error
            draft.success = success
            break
          case LOAD_EC_APP_SUCCESS:
            draft.app_list = app_list
            draft.lastUpdate = Math.floor(Date.now() / 1000)
            draft.loading = false
            draft.error = false
            draft.success = false
            break
            case LOAD_EC_EVENT_SUCCESS:
              draft.event_list = event_list
              draft.lastUpdate = Math.floor(Date.now() / 1000)
              draft.loading = false
              draft.error = false
              draft.success = false
              break
              case LOAD_DELIVERABLES_SUCCESS:
                draft.deliver_list = deliver_list
                draft.lastUpdate = Math.floor(Date.now() / 1000)
                draft.loading = false
                draft.error = false
                draft.success = false
                break
                case LOAD_CALL_CRITERIA_SUCCESS:
                  draft.criteria_data = criteria_data
                  draft.lastUpdate = Math.floor(Date.now() / 1000)
                  draft.loading = false
                  draft.error = false
                  draft.success = false
                  break
                  case LOAD_CALL_ACTIONS_SUCCESS:
                    draft.actions_data = actions_data
                    draft.lastUpdate = Math.floor(Date.now() / 1000)
                    draft.loading = false
                    draft.error = false
                    draft.success = false
                    break
                    case LOAD_CALL_RECORDING_SUCCESS:
                      draft.call_Records = call_Records
                      draft.lastUpdate = Math.floor(Date.now() / 1000)
                      draft.loading = false
                      draft.error = false
                      draft.success = false
                      break
      case LOAD_CALL_RECORDING_ERROR:
      case LOAD_DELIVERABLE_TAG_ERROR:
      case LOAD_CALL_CRITERIA_ERROR:
      case LOAD_CALL_ACTIONS_ERROR:
      case LOAD_ISSUES_ERROR:
      case LOAD_DELIVERABLE_STATUS_ERROR:
      case LOAD_DELIVERABLES_ERROR:
      case LOAD_EC_APP_ERROR:
      case LOAD_EC_EVENT_ERROR:
      case LOAD_EC_FOLLOWUP_LIST_ERROR:
      case LOAD_CHECK_LIST_ERROR:
      case LOAD_TEAM_SCHEDULE_ERROR:
      case LOAD_FOLLOWUP_LIST_ERROR:
        case LOAD_REVIEW_ERROR:
      case LOAD_RECORDS_META_DATA_ERROR:
        case LOAD_DELIVER_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      
    }
  })
}
